import React from "react";
import {connect} from "react-redux";
import {Button, Card, Checkbox, Col, Input, message, Modal, Row, Space, Table, Tag} from "antd";
import {
    ArrowRightOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    SettingOutlined
} from "@ant-design/icons";
import {MoneyField} from "./MoneyField";
import {createQuickIPAddressOrder} from "../../actions/ip_addresses";
import {displayErrors} from "../../libs/utils";
import isValidDomain from "is-valid-domain";
import {updatePanelMode} from "../../actions/account";
import {FiArrowRight} from "react-icons/fi";

class WebsiteLauncher extends React.Component {
    state = {
        defaultSettings: ['WordPress', 'SSL certificate', 'Automatic updates'],
        showDefaultSettings: false,
        domains: [],
        showDomainError: false,
        domainError: '',
        showOrderModal: false,
        loading: false,
        creatingQuickOrder: false,
        domainInput: ''
    }

    updateDefaultSettings(value, checked) {
        const defaultSettings = this.state.defaultSettings;

        if(defaultSettings.includes(value) && !checked) {
            defaultSettings.splice(defaultSettings.indexOf(value), 1);
        } else {
            defaultSettings.push(value);
        }

        this.setState({ defaultSettings });
    }

    validateDomains() {
        if(this.state.domains.length === 0) {
            this.setState({ showDomainError: true, domainError: 'Please enter at least 1 domain!' });
            return false;
        }

        for(let i = 0; i < this.state.domains.length; i++) {
            if(!isValidDomain(this.state.domains[i], { subdomain: false, allowUnicode: false })) {
                return this.setState({ showDomainError: true, domainError: '"' + this.state.domains[i] + '" is not a valid domain!' });
            }
        }

        this.setState({ showOrderModal: true });
    }

    placeOrder() {
        this.setState({ creatingQuickOrder: true });

        const group = this.props.user.user.ip_address_groups.find(item => item.is_internal);
        const domains = this.state.domains.map(domain => {
            return {
                domain: domain,
                ssl_certificate: this.state.defaultSettings.includes('SSL certificate'),
                wordpress: this.state.defaultSettings.includes('WordPress'),
                automatic_updates: this.state.defaultSettings.includes('Automatic updates'),
            }
        })

        let data = {
            ip_address_count: this.state.domains.length,
            domains: domains,
            group: group.guid,
        }

        this.props.createQuickIPAddressOrder(data, (res) => {
            message.success('Order successfully placed, redirecting to invoice...', 5);

            this.props.history.push('/billing/invoices/' + res.data.invoice_id);

            this.setState({ creatingQuickOrder: false });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ creatingQuickOrder: false });
                displayErrors(err.response.data);
            }

        })
    }

    updateDomains(data) {
        this.setState({ domainInput: data });

        if(data.startsWith('http:') || data.startsWith('https:')) {
            return this.setState({ showDomainError: true, domainError: 'Enter your domain without http(s)://!  For example: priorityprospect.com' })
        } else if(data.startsWith('www.')) {
            return this.setState({ showDomainError: true, domainError: 'Enter your domain without www.! For example: priorityprospect.com' })
        }

        const domains = [
            ...new Set(
                data.split('\n')
                    .map(d => d.trim().toLowerCase())
                    .filter(Boolean)
            )
        ];

        this.setState({ domains: domains, showDomainError: false, domainError: '' })
    }

    calculatePrice(showPrice = false) {
        let pricePerDomain = 2.89;

        if(this.props.user.user.company.currency === 'EUR') {
            pricePerDomain = pricePerDomain * this.props.user.user.company.conversion_rate;
        }

        if(showPrice) {
            return pricePerDomain;
        }

        const domains = this.state.domains;
        return domains.length * pricePerDomain;
    }

    render() {
        const { TextArea } = Input;

        const tableData = this.state.domains.map(domain => {
            return {
                key: domain,
                description: <span> <b>{domain}</b><br /><span style={{color: '#979696', fontSize: '12px'}}>Website hosting + dedicated IP from United States</span></span>,
                quantity: 1,
                cost: (this.props.user.user.company.currency === 'EUR' ? (2.89*this.props.user.user.company.conversion_rate).toFixed(2) : 2.89)
            }
        });

        const tableColumns = [
            { title: 'Description', dataIndex: 'description', width: '80%', align: 'left' },
            { title: 'Monthly Cost', dataIndex: 'cost', align: 'right', render: (val) => <MoneyField amount={val} currency={this.props.user.user.company.currency} /> },
        ]

        return <Card style={{marginBottom: '20px', borderRadius: '10px', borderTop: '5px solid rgba(211, 0, 130, 0.2)'}}>
            <Row>
                <Col span={24}>
                    <h2>🚀 Launch New Websites</h2>
                    <p className='secondary-text'>Enter your domains and we'll handle the setup for you.</p>
                </Col>
            </Row>
            <Row align='middle' justify='center'>
                <Col xxl={{span: 18}} sm={{span: 16}}>
                    <div style={{marginBottom: '10px'}}>Enter the domains you want to host:</div>
                    {this.state.showDomainError ? <div style={{backgroundColor: '#fd06060d', color: '#b93a3a', padding: '5px 10px', marginBottom: '5px', borderRadius: '5px', border: '1px solid #ebc6c6'}}><CloseCircleOutlined style={{color: '#b93a3a'}} /> {this.state.domainError}</div> : null}

                    <TextArea
                        rows={7}
                        placeholder='priorityprospect.com'
                        value={this.state.domainInput || ''}
                        onBlur={(e) => {
                            const domains = [
                                ...new Set(
                                    e.target.value.split('\n')
                                        .map(domain => domain.trim().toLowerCase())
                                        .filter(Boolean)
                                )
                            ];

                            this.updateDomains(domains.join('\n'));
                        }}
                        onChange={(e) => this.updateDomains(e.target.value.toLowerCase())} />

                    <div style={{color: 'rgb(107, 107, 107)', paddingTop: '10px'}}>
                        <small>IP address location: United States (automatically assigned)</small>
                    </div>

                    <div style={{padding: '10px 10px 10px 15px', marginTop: '10px', backgroundColor: 'rgba(211, 0, 130, 0.05)', borderRadius: '5px'}}>
                        <Row align="middle">
                            <Col xxl={{span: 20}} sm={{span: 18}}>
                                <div>Default settings will be applied:</div>
                                <div>{this.state.defaultSettings.length === 0 ? 'None' : this.state.defaultSettings.map(item => <Tag key={item} icon={<CheckCircleOutlined />} color='purple'>{item}</Tag>)}</div>
                            </Col>
                            <Col xxl={{span: 4}} sm={{span: 6}} className='text-right'>
                                <Button type='text' icon={<SettingOutlined />} onClick={() => this.setState({ showDefaultSettings: !this.state.showDefaultSettings })}>Edit defaults</Button>
                            </Col>
                        </Row>
                        {this.state.showDefaultSettings ? <Row >
                            <Col span={24}>
                                <Checkbox checked={this.state.defaultSettings.includes('WordPress')} onChange={(e) => this.updateDefaultSettings('WordPress', e.target.checked)}>WordPress</Checkbox>
                                <Checkbox checked={this.state.defaultSettings.includes('SSL certificate')} onChange={(e) => this.updateDefaultSettings('SSL certificate', e.target.checked)}>SSL certificate</Checkbox>
                                <Checkbox checked={this.state.defaultSettings.includes('Automatic updates')} onChange={(e) => this.updateDefaultSettings('Automatic updates', e.target.checked)}>Automatic updates</Checkbox>
                            </Col>
                        </Row> : null}
                    </div>

                    <Card size='small' className='clean' style={{marginTop: '15px'}}>
                        <div><b>Want to choose your IP locations?</b></div>
                        <div style={{color: 'rgb(107, 107, 107)'}}>Select from 46 locations and 86+ data centers worldwide using Advanced mode.</div>
                        <div style={{cursor: 'pointer'}} onClick={() => {
                            this.props.updatePanelMode({'panel_mode': 'ADVANCED'}, () => {
                                window.location.reload();
                            })
                        }}>
                            Switch to advanced mode <FiArrowRight style={{marginBottom: '-3px'}} />
                        </div>
                    </Card>

                </Col>
                <Col xxl={{span: 6}} sm={{span: 8}}>
                    <div className='text-center' style={{width: '210px', margin: '0 auto', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                        {this.state.domains.length === 0 ?
                            <>
                                <span>Hosting starts at:</span>
                                <span style={{fontSize: '48px', fontWeight: '400', marginBottom: '30px'}}>
                                    <MoneyField amount={this.calculatePrice(true)} currency={this.props.user.user.company.currency} />
                                    <div style={{fontSize: '11px', fontStyle: 'italic'}} className='text-center'>Per domain. Excluding VAT.</div>
                                </span>
                            </> :
                            <>
                                <span>Per month:</span>
                                <span style={{fontSize: '48px', fontWeight: '400', marginBottom: '30px'}}>
                                    <MoneyField amount={this.calculatePrice()} currency={this.props.user.user.company.currency} />
                                    <div style={{fontSize: '11px', fontStyle: 'italic'}} className='text-center'>{this.state.domains.length} domain{this.state.domains.length > 1 ? 's' : ''} × $2.89/month.<br />Excluding VAT.</div>
                                </span>
                            </>
                        }

                        <div style={{marginBottom: '30px'}}>
                            <ul style={{listStyle: 'none', margin: '0', padding: '0'}}>
                                <li><small><CheckCircleOutlined style={{color: 'green'}} /> Dedicated IP address for each domain</small></li>
                                <li><small><CheckCircleOutlined style={{color: 'green'}} /> cPanel hosting account</small></li>
                                <li><small><CheckCircleOutlined style={{color: 'green'}} /> Instant setup</small></li>
                            </ul>
                        </div>
                        <Button type='primary' disabled={this.state.domains.length === 0} onClick={() => this.validateDomains()}>Review Order <ArrowRightOutlined /></Button>
                    </div>
                </Col>
            </Row>

            <Modal
                open={this.state.showOrderModal}
                centered
                title='Order Overview'
                width={800}
                onCancel={() => this.setState({ showOrderModal: false })}
                footer={<Space>
                    <Button onClick={() => this.setState({ showOrderModal: false })} disabled={this.state.creatingQuickOrder}>Back</Button>
                    <Button type='primary' onClick={() => this.placeOrder()} loading={this.state.creatingQuickOrder} disabled={this.state.creatingQuickOrder}>Place Order</Button>
                </Space>}>

                <Table
                    dataSource={tableData}
                    columns={tableColumns}
                    rowKey='key'
                    pagination={false}
                    size='small'
                    summary={(data) => {
                        const totalCost = data.map(item => parseFloat(item.cost)).reduce((acc, current) => acc+current, 0);

                        return <>
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={1} className='text-right'><b>Total per month</b></Table.Summary.Cell>
                                <Table.Summary.Cell index={2} className='text-right'>
                                    <b><MoneyField amount={totalCost} currency={this.props.user.user.company.currency} /></b>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    }}
                />

                <div style={{color: 'rgba(0, 0, 0, 0.6)', fontSize: '12px', marginTop: '10px'}}>
                    <div>Your subscription will renew automatically at the end of each billing term unless canceled before the renewal date via the customer panel.</div>
                    <div>By completing this order, you confirm that the Services are provided in accordance with Priority Prospect OÜ's <a href='https://priorityprospect.com/legal/terms-of-service/' target='_blank' rel='noreferrer noopener'>Terms of Service</a> including billing, renewal, and refund provisions.</div>
                </div>
            </Modal>
        </Card>;
    }
}

const mapStateToProps = state => ({
    user: state.auth.user
});

export default connect(mapStateToProps, { createQuickIPAddressOrder, updatePanelMode })(WebsiteLauncher);